import resolve from '../../../modules/api/resolve';
import { apiPost, generateFormData } from '../../../modules/apiHelper';

export default {
  async getUserGoalsBadges(context, userId) {
    const formData = generateFormData({
      userid: userId || context.rootState.user.id,
      progid: context.rootState.user.programid,
    });

    const userGoalsBadges = await resolve(apiPost('prog_my_goal_badge_list', formData, 73));

    if (userGoalsBadges) {
      return userGoalsBadges.prog_my_goal_badge_list;
    }

    return [];
  },
};
